import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { NavItem } from './NavItem';

export const Nav = () => {
    const { active_tab: activeTab } = useParams();

    useEffect( () => {
        // Disable sticky behavior on main menu.
        document.querySelector( 'body' ).classList.add( 'disable-nav-fix' );

        const tab = activeTab || 'home';

        const currentlyActive = document.querySelector(
            '.js-statspro-container.active'
        );
        
        if ( currentlyActive ) {
            currentlyActive.classList.remove( 'active' );
            currentlyActive.classList.add( 'u-hide' );
        }

        const newActive = document.querySelector( `[data-tab="${ tab }"]` );
        if ( newActive ) {
            newActive.classList.add( 'active' );
            newActive.classList.remove( 'u-hide' );
        }
    } );

    return (
        <nav className="statspro-nav">
            <ul className='statspro-nav__list'>
                <NavItem
                    path="/"
                    icon="chart-v2"
                    translationLabel="label.statspro.statsHome"
                />
                <NavItem
                    path="/leaders"
                    icon="list-number"
                    translationLabel="label.statspro.statsLeaders"
                />
            </ul>
        </nav>
    );
};